import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export const SUBJECTS = [
    "Anatomy",
    "Physiology",
    "Biochemistry",
    "Pathology",
    "Pharmacology",
    "Microbiology",
    "PDCM",
    "Epidemiology/Biostatistics",
    "Histology",
    "Behavioral Sciences"
];

export const ORGAN_SYSTEMS = [
    "Cardiovascular",
    "Respiratory",
    "Gastrointestinal",
    "Renal/Urinary",
    "Endocrine",
    "Exocrine",
    "Reproductive",
    "Musculoskeletal",
    "Nervous System",
    "Hematology/Oncology",
    "Immunology",
    "Dermatology",
    "Psychiatry",
    "Hepatobiliary",
    "Ophthalmology",
    "ENT/Head & Neck",
    "Lymphatic"
];

export const SUBJECT_COLORS = {
    Anatomy: { bg: "bg-rose-100", text: "text-rose-700", border: "border-rose-200" },
    Physiology: { bg: "bg-sky-100", text: "text-sky-700", border: "border-sky-200" },
    Biochemistry: { bg: "bg-amber-100", text: "text-amber-700", border: "border-amber-200" },
    Pathology: { bg: "bg-purple-100", text: "text-purple-700", border: "border-purple-200" },
    Pharmacology: { bg: "bg-emerald-100", text: "text-emerald-700", border: "border-emerald-200" },
    Microbiology: { bg: "bg-indigo-100", text: "text-indigo-700", border: "border-indigo-200" },
    PDCM: { bg: "bg-teal-100", text: "text-teal-700", border: "border-teal-200" },
    "Epidemiology/Biostatistics": { bg: "bg-orange-100", text: "text-orange-700", border: "border-orange-200" },
    Histology: { bg: "bg-pink-100", text: "text-pink-700", border: "border-pink-200" },
    "Behavioral Sciences": { bg: "bg-cyan-100", text: "text-cyan-700", border: "border-cyan-200" },
};

export const SYSTEM_COLORS = {
    "Cardiovascular": { bg: "bg-red-100", text: "text-red-700" },
    "Respiratory": { bg: "bg-blue-100", text: "text-blue-700" },
    "Gastrointestinal": { bg: "bg-yellow-100", text: "text-yellow-700" },
    "Renal/Urinary": { bg: "bg-amber-100", text: "text-amber-700" },
    "Endocrine": { bg: "bg-purple-100", text: "text-purple-700" },
    "Exocrine": { bg: "bg-lime-100", text: "text-lime-700" },
    "Reproductive": { bg: "bg-pink-100", text: "text-pink-700" },
    "Musculoskeletal": { bg: "bg-orange-100", text: "text-orange-700" },
    "Nervous System": { bg: "bg-indigo-100", text: "text-indigo-700" },
    "Hematology/Oncology": { bg: "bg-rose-100", text: "text-rose-700" },
    "Immunology": { bg: "bg-green-100", text: "text-green-700" },
    "Dermatology": { bg: "bg-teal-100", text: "text-teal-700" },
    "Psychiatry": { bg: "bg-violet-100", text: "text-violet-700" },
    "Hepatobiliary": { bg: "bg-emerald-100", text: "text-emerald-700" },
    "Ophthalmology": { bg: "bg-sky-100", text: "text-sky-700" },
    "ENT/Head & Neck": { bg: "bg-fuchsia-100", text: "text-fuchsia-700" },
    "Lymphatic": { bg: "bg-cyan-100", text: "text-cyan-700" },
};

export const DIFFICULTY_COLORS = {
    easy: { bg: "bg-emerald-100", text: "text-emerald-700" },
    medium: { bg: "bg-amber-100", text: "text-amber-700" },
    hard: { bg: "bg-red-100", text: "text-red-700" },
};

export function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
}

export function formatPercentage(value) {
    return `${Math.round(value)}%`;
}
